import React from 'react'

export default function DescriptionBox ({ icon, description }) {
  return (
    <div className='content-marketing-box-container'>
      {icon && <img className='content-marketing-box-icon lazyload' src={icon} width='40' height='40' />}
      <div className='content-marketing-box-description' dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  )
}
